<template>
    <div class="p-2">
        <b-modal id="upload-file" title="Dosya Yükle" no-close-on-esc no-close-on-backdrop>
            <inventory-document-upload v-model="file"></inventory-document-upload>
            <template #modal-footer><v-executer :laoding="loading" title="Yükle" :action="uploadFile"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :fields="fields"
                    :buttons="buttons"
                    name="inventory-document"
                    :add-callback="createNew"
                    :items-provider="provider"
                    pagination="server"></v-table>
    </div>
</template>

<script>
import VehicleOperationsApi from '@/api/vehicle-operations' 
import Additional from '@/utilities/additional'
import InventoryDocumentUpload from './InventoryDocumentUpload.vue'
export default {
    components:{
        InventoryDocumentUpload
    },
    props:{
        id:[String,Number],
    },
    data(){
        return{
            fields:[
                {name:"Dosya Türü",key:"FileType",thClass:"w-60"},
                {name:"Yükleme Tarihi",key:"CreateDate",thClass:"w-40"}
            ],
            buttons:[
                { text:"İndir",key:"download",icon:"DownloadIcon",variant:"primary",action:this.download },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            loading:false,
            file:{
                Id: null,
                VehicleInventoryId: null,
                File: null,
                SystemCode: null
            }
        }
    },
    methods:{
        clearForm(){
            this.file.Id = null
            this.file.VehicleInventoryId = null
            this.file.File = null
            this.file.SystemCode = null
        },
        provider(data){
            return VehicleOperationsApi.Inventory.File.Table({PaginationRequestModel:data,VehicleInventoryId:this.id})
        },
        createNew(){
            this.clearForm()
            this.$showModal('upload-file')
        },
        download(item){
            this.$refs.table.rowLoading(true)
            Additional.GetBlobFile(item.FileDownloadUrl).then(res=>{
                Additional.DownloadFile(res.data,Additional.ApiFileName(item.FileDownloadUrl))
                this.$refs.table.rowLoading(false)
            }).catch(err=>{
                this.$result(null,err)
                this.$refs.table.rowLoading(false)
            })
        },
        async uploadFile(){
            this.loading = true
            this.file.VehicleInventoryId = this.id
            let formData = await Additional.ToFormData(this.file,['File'])
            VehicleOperationsApi.Inventory.File.Upload(formData).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('upload-file')
                }
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.FileType} türlü dosyayı silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    VehicleOperationsApi.Inventory.File.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>
